import React from 'react';
import PropTypes from 'prop-types';

import GroupSelect from 'bento-ordering/base/components/GroupSelect';

const TimePicker = ({
  value,
  onChange,
  name,
  id,
  disabled,
  label,
  options
}) => (
  <GroupSelect
    value={value}
    onChange={onChange}
    id={id}
    name={name}
    disabled={disabled}
    label={label}
    options={options}
  />
);

TimePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  label: PropTypes.string
};

export default TimePicker;
